<template>
  <div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h1>Registro de Cargas de Petróleo</h1>
          </div>
          <div class="col text-right">
            <button class="btn btn-success" @click="agregar"><i class="fas fa-plus"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h4>RANGO DE FECHAS</h4>
            <date-picker v-model="fechas" @change="filtrar" :range="true" format="DD-MM-YYYY" :editable="false"
              :clearable="true" value-type="YYYY-MM-DD"></date-picker>

          </div>
          <div class="col">
            <h4>PATENTE</h4>
            <v-select class="" :reduce="(option) => option.id" v-model="transportes_id" :closeOnSelect="false"
              :options="camiones" label="patente" multiple v-on:change="filtrar">
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  No se Encontraron Resultados Para
                  <em>{{ search }}</em>.
                </template>
                <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
              </template>
            </v-select>
          </div>
        </div>

        <!-- <div class="row mt-2">
          <div class="col">

            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <h5 class="mb-0">Filtro</h5>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div class="card-body">

                    <div class="row">
                      <div class="col">
                        <div class="table-responsive">

                          <table class="table table-bordered">
                            <tr class="background-light">
                              <th>RANGO DE FECHAS</th>
                              <th>PATENTE</th>

                            </tr>
                            <tr>
                              <td>
                                <date-picker v-model="fechas" @change="filtrar" :range="true" format="DD-MM-YYYY"
                                  :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                              </td>
                              <td>
                                <v-select class="" :reduce="(option) => option.id" v-model="transportes_id"
                                  :closeOnSelect="false" :options="camiones" label="patente" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                              </td>
                            </tr>
                          </table>
                        </div>




                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

    </div>

    <div class="row">
      <div class="col">
        <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="errores.length > 0">
          <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
          <ul>
            <li v-for="(m, index) in errores" :key="index">{{ `${m}` }}</li>
          </ul>

          <button type="button" class="close" @click="errores = []" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <div class="card fixTableHead2" style="height: 100%;">
      <table class="table align-items-center table-flush">
        <thead class="">
          <tr class="cabecera1 thead-skyblue4">
            <th class="text-center" scope="col">Fecha Carga</th>
            <th class="text-center" scope="col">N° Folio</th>
            <th class="text-center" scope="col">Patente</th>
            <th class="text-center" scope="col">N° Vuelta</th>
            <th class="text-center" scope="col">Kilometraje Odometro</th>
            <th class="text-center" scope="col">Kilometraje Manual</th>
            <th class="text-center" scope="col">Litros</th>
            <th class="text-center" scope="col">Guardar</th>
            <th class="text-center" scope="col">Eliminar</th>

          </tr>
        </thead>
        <tbody class="list">
          <tr v-for="(item, idx) in lista" :key="idx">
            <td class="text-center">
              <input type="datetime-local" class="form-control-sm" name="" id="" placeholder="dd-mm-aaaa hh:mm"
                v-model="item.fecha">
            </td>
            <td class="text-center">
              <input style="width:80px;" type="number" name="" id="" v-model="item.nro_folio">
            </td>
            <td class="text-center">
              <v-select style="width:130px;" :reduce="option => option.id" :options="camiones" label="patente"
                v-model="item.transportes_id">
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                  </template>
                  <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                </template>
              </v-select>
            </td>
            <td class="text-center">
              <template v-if="item.viaje">
                <i class="fas fa-truck" style="cursor:pointer"
                  :title="`N° Viaje: ${item.viaje.ingreso_vehiculos_porteria_id}\nPatente: ${item.viaje.patente}\nFecha Ingreso Porteria: ${$moment(item.viaje.fecha_ingreso).format('DD-MM-YYYY HH:mm')}`"></i>
                {{ item.viaje.ingreso_vehiculos_porteria_id }}
              </template>
            </td>
            <td class="text-center">
              <input style="width:80px;" type="number" name="" id="" v-model="item.kilometraje_odometro">
            </td>
            <td class="text-center">
              <input style="width:80px;" type="number" name="" id="" v-model="item.kilometraje_manual">
            </td>
            <td class="text-center">
              <input style="width:80px;" type="number" name="" id="" v-model="item.litros">
            </td>
            <td class="text-center">
              <button class="btn btn-success" @click="guardar(item, idx)"><i class="fas fa-save"></i></button>
            </td>
            <td class="text-center">
              <button class="btn btn-danger" @click="eliminar(item, idx)"><i class="fas fa-trash"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ModalCrearEditar from '../../components/Modal/ModalEditarCrear'
import Tabla from '../../components/Tabla/Tabla'
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    lista: [],
    fechas: [],
    camiones: [],
    transportes_id:[],
    errores: []
  }),
  mounted() {
    /* $('#empresas').DataTable({
        language: lenguaje
    }); */
    this.$emit('spinner', true);
    this.cargar_transportes();
  },
  methods: {
    async cargar_transportes() {
      await this.axios.get(`${this.api}/transportes?limit=99999999`, this.cabeceras_json).then((res) => {
        this.camiones = res.data.data.data;
        //this.$set(this.columnas[3],'opciones',res.data.data.data);
        //this.$set(this.inputs[3],'opciones',res.data.data.data);
      }).catch(e => {
        //alert(e);
      })
      this.cargar('')
    },
    async cargar($event) {
      this.$emit('spinner', true);
      this.pagina_actual = `${this.api}/cargas_petroleo${$event}`;
      this.lista = [];
      await this.axios.get(`${this.api}/cargas_petroleo${$event}`, this.cabeceras_json).then((res) => {
        this.lista = res.data.data.data;
        this.setear_fecha();
      }).catch(e => {
        //alert(e);
      })
      this.$emit('spinner', false);
    },

    async filtrar() {
      let body = {
        desde: this.fechas[0],
        hasta: this.fechas[1],
        transportes_id: this.transportes_id
      };
      await this.axios.post(`${this.api}/cargas_petroleo/filtrar`, body, this.cabeceras_json).then(res => {
        this.lista = res.data.data;
        this.setear_fecha();
      }).catch(e => {
        console.log(e);
      })
    },

    setear_fecha() {
      this.lista.forEach((i, idx) => {
        if (i.fecha) {
          let userAgent = navigator.userAgent;
          if (userAgent.match(/chrome|chromium|crios/i)) {
            let fecha = this.$moment(i.fecha).format("YYYY-MM-DDTHH:mm");
            this.$set(this.lista[idx], 'fecha', fecha);


          } else if (userAgent.match(/firefox|fxios/i)) {
            this.$set(this.lista[idx], 'fecha', this.$moment(i.fecha).format('YYYY-MM-DDTHH:mm'));
          } else if (userAgent.match(/safari/i)) {

          } else if (userAgent.match(/opr\//i)) {

          } else if (userAgent.match(/edg/i)) {

          } else {
            //no encontro navegador
          }

        }
      });
    },

    agregar() {
      this.lista.unshift({
        id: null,
        fecha: null,
        nro_folio: null,
        kilometraje_odometro: null,
        kilometraje_manual: null,
        transportes_id: null,
        viajes_camiones_id: null,
      });
    },

    async guardar(item, idx) {
      if (item.id == null) {
        this.axios.post(`${this.api}/cargas_petroleo`, item, this.cabeceras_json).then(res => {
          if (res.data.codigo == 400) {
            this.errores = res.data.data;
          } else {
            this.$set(this.lista[idx], 'id', res.data.data.id);
            this.$set(this.lista[idx], 'detalle_viaje', res.data.data.detalle_viaje);
            this.$set(this.lista[idx], 'viaje', res.data.data.viaje);
          }
          console.log('res', res.data);
        }).catch(e => {
          console.log('error', e);
        });
      } else {
        this.axios.put(`${this.api}/cargas_petroleo/${item.id}`, item, this.cabeceras_json).then(res => {
          console.log('res', res.data);
          if (res.data.codigo == 400) {
            this.errores = res.data.data;
          } else {
            this.$set(this.lista[idx], 'id', res.data.data.id);
            this.$set(this.lista[idx], 'detalle_viaje', res.data.data.detalle_viaje);
            this.$set(this.lista[idx], 'viaje', res.data.data.viaje);
          }

        }).catch(e => {
          console.log('error', e);
        })
      }
    },

    async eliminar(item, idx) {
      //console.log('eliminando',item,idx);
      //this.lista.splice(idx,1);
      //console.log('eliminando 2',item,idx);
      this.$confirm(
        {
          title: `Esta a Punto de Eliminar un Registro de Carga de Petróleo`,
          message: `¿Continuar con la eliminación?`,
          button: {
            no: 'No',
            yes: 'Si, Eliminar.'
          },
          callback: async confirm => {
            console.log('siuuuu')
            if (confirm) {

              if (item.id != null) {
                await this.axios.delete(`${this.api}/cargas_petroleo/${item.id}`, this.cabeceras_json).then((res) => {
                  //this.cargar('');
                }).catch((e) => {
                  console.log(e);
                })
              }

              this.lista.splice(idx, 1);
            }
          }
        }
      )

    },
    ...mapActions(['inicializar_tabla', 'setear_lista', 'setear_inputs'])
  },
  components: {
    'modal-crear-editar': ModalCrearEditar,
    'tablita': Tabla
  },
  computed: {
    ...mapState(['api', 'cabeceras_json']),
    query() {
      let string = '?';
      let and = '';
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = '&';
        } else if (index == total) {
          and = '';
        }

        if (c.busqueda != '') {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },


  }
}
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>